import { StatusBox } from '@page-components/catalog-settings/tabs/MarketplacesTab';
import { Tooltip } from '@skupreme/shared/ui';
import { X } from '@phosphor-icons/react';

type MarketplaceErrorItem = {
  reason?: string;
  error_details?: string;
};

type MarketplaceErrorProps = {
  errors: MarketplaceErrorItem[];
  marketplace: string;
};

/** The marketplace's unresolved errors, listed in a tooltip over an "Error" mark. */
function MarketplaceError({ errors, marketplace }: MarketplaceErrorProps) {
  const errorItems = errors.map(d => ({
    desc: d?.error_details,
    key: d?.reason,
    status: 0,
    text: d?.reason,
  }));

  return (
    <Tooltip
      placement="top"
      content={
        <StatusBox items={errorItems} marketplace={marketplace} isError />
      }
    >
      <span className="sk:inline-flex sk:items-center sk:justify-center sk:gap-1 sk:whitespace-nowrap sk:text-dense sk:text-danger">
        <X size={16} weight="bold" aria-hidden />
        <span>Error</span>
      </span>
    </Tooltip>
  );
}

export default MarketplaceError;
